import { CommodityMilestone, CommodityStatusCode, ProjectMilestoneType } from '@bechtel/types';
export interface WeldSendBackProps {
  currentMilestone: CommodityMilestone;
  fitUpMilestone: CommodityMilestone;
  commodityStatus: CommodityStatusCode;
  fitupProjectMilestoneDetails: ProjectMilestoneType;
  isSendBackToForeman?: boolean;
  isFitupExist?: boolean;
  onClose: () => void;
  refetchQueries?: string[];
}
